import {Box, Button, ButtonProps, CircularProgress} from '@mui/material';
import {AnimateButton} from 'components/Theme';
import React, {useMemo} from 'react';

export interface AppButtonProps extends ButtonProps {
    children: string | React.ReactNode;
    isLoading?: boolean;
    isAnimated?: boolean;
}

export const AppButton: React.FC<AppButtonProps> = ({children, isLoading, disabled, isAnimated, ...props}) => {
    const renderButton = useMemo(() => {
        return (
            <Button size="small" color="primary" variant="contained" disabled={isLoading || disabled} {...props}>
                <Box>{isLoading ? <CircularProgress style={{marginTop: '5px'}} size={14} /> : children}</Box>
            </Button>
        );
    }, [isLoading, disabled, props, children]);
    return <>{isAnimated ? <AnimateButton>{renderButton}</AnimateButton> : renderButton}</>;
};

export default AppButton;
